import FastForwardIcon from '@mui/icons-material/FastForward';
import { Backdrop, Box, Button, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const emphasisRed = (
  <Box component="span" sx={{ fontWeight: 700, color: '#b91c1c' }} />
);

interface PalSkipQuestionPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirmSkip: () => void;
}

export const PalSkipQuestionPopup = ({
  open,
  onClose,
  onConfirmSkip,
}: PalSkipQuestionPopupProps) => {
  const { t } = useTranslation();

  return (
    <Backdrop
      open={open}
      onClick={onClose}
      sx={{
        zIndex: 1400,
        bgcolor: 'rgba(17, 24, 39, 0.55)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          width: { xs: 'calc(100% - 32px)', sm: 440 },
          maxWidth: 440,
          bgcolor: 'white',
          borderRadius: '24px',
          px: { xs: 3, sm: 4 },
          py: 4,
          textAlign: 'center',
          boxShadow: '0 24px 64px rgba(15, 23, 42, 0.2)',
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: '#fce7f3',
            border: '2px solid #fbcfe8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <FastForwardIcon sx={{ fontSize: 28, color: '#1e293b' }} />
        </Box>

        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 800,
            color: '#1e293b',
            mb: 1.5,
            lineHeight: 1.25,
          }}
        >
          {t('PAL_Q_SKIP_TITLE')}
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            color: '#64748b',
            lineHeight: 1.55,
            mb: 2.5,
            px: 0.5,
          }}
        >
          <Trans i18nKey="PAL_Q_SKIP_INTRO" components={{ emphasis: emphasisRed }} />
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 600,
            color: '#475569',
            mb: 2.5,
          }}
        >
          {t('PAL_Q_SKIP_CONFIRM')}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 1.5,
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={onClose}
            sx={{
              flex: 1,
              py: 1.35,
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 700,
              fontSize: 15,
              bgcolor: '#66bb6a',
              boxShadow: '0 4px 14px rgba(102,187,106,0.35)',
              '&:hover': { bgcolor: '#4caf50' },
            }}
          >
            {t('PAL_Q_SKIP_STAY')}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={onConfirmSkip}
            sx={{
              flex: 1,
              py: 1.35,
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 700,
              fontSize: 15,
              color: '#be123c',
              borderColor: '#fda4af',
              bgcolor: 'white',
              '&:hover': {
                borderColor: '#fb7185',
                bgcolor: '#fff1f2',
              },
            }}
          >
            {t('PAL_Q_SKIP_CONFIRM_BTN')}
          </Button>
        </Box>
      </Box>
    </Backdrop>
  );
};
